import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import firebase from 'firebase/compat/app';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor {
  constructor(public auth: AuthService,private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = firebase.auth().currentUser;
if (user) {
  return from(user.getIdToken()).pipe(
    switchMap(token => {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(request);
    })
  );
} else {
  // Handle the case where there is no authenticated user (e.g., by returning an empty observable or taking some other action).
  // For example:
  this.router.navigate(['/login']);
  return throwError('User is not authenticated'); // You can customize the error message as needed.
}

  }
}
